export default "__VITE_ASSET__BOUDD6yz__"